import type { GridElementType, GridProps } from "./Grid";
import { Grid as GridComponent } from "./Grid";
import type { GridItemProps, GridItemElementType } from "./Item";
import { GridItem } from "./Item";

export interface GridCompound extends React.FC<GridProps> {
  Item: React.FC<GridItemProps>;
}

const Grid: GridCompound = Object.assign(GridComponent, {
  Item: GridItem,
});

Grid.displayName = "Grid";
export { Grid };
export type { GridProps, GridItemProps, GridElementType, GridItemElementType };
